import React from "react";
import {Translation as T} from "@awe-web/shared/lib";
import {ScreenSection, ScreenHeading} from "../../../components/screen.js";
import {TypeArea} from "../../../components/layout.js";
import History from "../../../history/components/history";

const TITLE = "FSD0000311";

export default function MyBmwRentRentContracts() {
  return (
    <div>
      <ScreenSection main dark>
        <TypeArea>
          <ScreenHeading><T code={TITLE} /></ScreenHeading>
          <History />
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
